export const environment = {
  production: true,
  buildId: '3728057695223211',
  configFile: 'config.json',
};
